<template>
  <div
    v-if="baseOption && baseOption.options.length > 0"
    class="product-variant-selector"
  >
    <template v-if="baseOption.code === 'color'">
      <fn-color-selector
        v-model:value="model"
        :items="normalizedOptions"
        :label="baseOption.title"
        @input="(value) => $emit('input', value)"
      />
    </template>
    <template v-else-if="simpleDropdown">
      <fn-choices
        id="product-variant-selector-choices"
        :value="value"
        :label="baseOption.title"
        :options="normalizedOptions"
        is-simple
        options-as-links
        seo-content
        @update:value="(value) => $emit('input', value)"
      />
    </template>
    <template v-else-if="isSlider">
      <fn-product-variant-slider
        :options="normalizedOptions"
        :value="value"
        :aria-label="$t('accessibility.general.productVariants')"
        @input="(value) => $emit('input', value)"
      />
    </template>
    <template v-else-if="baseOption.options.length > 4">
      <fn-choices
        id="product-variant-selector-choices"
        :label="baseOption.title"
        :options="normalizedOptions"
        :value="value"
        options-as-links
        seo-content
        @update:value="(value) => $emit('input', value)"
      >
        <template #expandedHandle>
          <div class="pvs-choices-handle-expanded">
            <div>{{ baseOption.title }}</div>
            <div>{{ $t('product.price') }}</div>
          </div>
        </template>
        <template #default="{ option }">
          <fn-product-variant-selector-item
            :item="option"
            :tabindex="null"
            :value="value"
            @change-tab="(tab) => $emit('changeTab', tab)"
          />
        </template>
      </fn-choices>
    </template>
    <template v-else>
      <fn-product-variant-selector-item
        v-for="(option, index) in normalizedOptions"
        :key="option.code"
        :index="index"
        :item="option"
        :value="value"
        display-as-link
        new-style
        @change-tab="(tab) => $emit('changeTab', tab)"
        @input="(value) => $emit('input', value)"
      />
    </template>
  </div>
</template>

<script>
import { STOCK_LEVEL_STATUS_OUTOFSTOCK } from '@/utils/stock';

export default defineComponent({
  props: {
    baseOption: {
      type: Object,
      required: true,
    },
    value: {
      type: String,
      default: null,
    },
    simpleDropdown: {
      default: false,
      type: Boolean,
    },
    isSlider: {
      default: true,
      type: Boolean,
    },
  },
  emits: ['input', 'changeTab'],
  computed: {
    normalizedOptions() {
      const options = [];

      for (let i = 0; i < this.baseOption.options.length; i += 1) {
        let option = this.baseOption.options[i];

        if (
          option.length > 1 &&
          option.stockLevelStatus === STOCK_LEVEL_STATUS_OUTOFSTOCK &&
          option.url !== this.$route.path
        ) {
          option.forEach((item) => {
            if (item.stockLevelStatus !== STOCK_LEVEL_STATUS_OUTOFSTOCK) {
              option = {
                label: item.value,
                name: item.value,
                url: item.url,
                stock: item.stock,
                color: item.color,
              };
            }
          });

          option.name = option.value;
        }

        option.badges = option.badges.filter((b) => b.type !== 'discount');

        options.push({
          name: option.value,
          label: option.value,
          value: option.url,
          url: option.url,
          color: option.color || null,
          pricing: option.pricing,
          highestSavings: option.highestSavings,
          selected: option.selected,
          stockLevelStatus: option.stockLevelStatus,
          badges: option.badges,
        });
      }

      return options;
    },
  },
});
</script>

<style lang="scss" scoped>
.product-variant-selector {
  .pvs-choices-handle-expanded {
    display: flex;
    padding: 0 $pad;
    margin: 0 -5px;

    div {
      font-weight: bold;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:nth-child(1) {
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: span-columns(4);
        margin: 0 math.div($grid-margin-width, 2);
      }

      &:nth-child(2) {
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: span-columns(8);
        margin: 0 math.div($grid-margin-width, 2);
        padding-left: 12px;
      }
    }
  }
}
</style>
